<div class="centered-content-page">
  <div class="login-wrapper">
    <h2>
      <span>Welcome to </span><span class="primary">REA UI</span>
    </h2>
    <hr>
    <h4>You will soon be redirected ...</h4>
    <img src="assets/img/workspace.png" alt="Login"></div>
</div>
